import Request from "@/common/net/request.js";
const request = new Request();

export function getCode(id) {
  return request.send({
    url: `/pmy/sys/login/captcha?loginId=${id}`,
    method: "get",
  });
}
// 是否需要验证码登录
export function haveCode(phone) {
  return request.send({
    url: `/pmy/sys/login/captcha/state`,
    method: "get",
  });
}

// 获取随机数
export function getRandom(phone) {
  return request.send({
    url: `/pmy/sys/login/login/id`,
    method: "get",
  });
}

// 获取用户信息
export function getUserInfo(phone) {
  return request.send({
    url: `/pmy/sys/login/info`,
    method: "get",
  });
}

// 修改密码时发送短信验证码
export function updatePassSms(phone) {
  return request.send({
    url: `/system/sms/login?phone=${phone}`,
    method: "get",
  });
}
// 忘记密码发送短信
export function forgetPassSms(phone) {
  return request.send({
    url: `/system/sms/forget-pwd?phone=${phone}`,
    method: "get",
  });
}
// 登录时发送短信验证码
export function loginSms(phone) {
  return request.send({
    url: `/system/sms/login?phone=${phone}`,
    method: "get",
  });
}

// 注册时发送短信验证码
export function registerSms(phone) {
  return request.send({
    url: `/system/sms/register?phone=${phone}`,
    method: "get",
  });
}

// 管理端添加用户时发送短信验证码
export function userSms(phone) {
  return request.send({
    url: `/system/sms/user?phone=${phone}`,
    method: "get",
  });
}

// 修改手机号时发送短信验证码
export function changePhoneSms(phone) {
  return request.send({
    url: `/system/sms/change-phone?phone=${phone}`,
    method: "get",
  });
}
// 添加经纪人时发送短信验证码
export function brokerSms(phone) {
  return request.send({
    url: `/system/sms/broker?phone=${phone}`,
    method: "get",
  });
}

// WEB端--密码登录
export function login(data) {
  return request.send({
    url: `/pmy/sys/login/web/pwd`,
    method: "post",
    data: data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 忘记密码-修改密码
export function updatePass(data) {
  return request.send({
    url: `/system/sys/forget-pwd`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 登录 短信
export function loginCode(data) {
  return request.send({
    url: `/pmy/sys/login/web/sms`,
    method: "post",
    data: data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
